import React from 'react'
import {
  Grid,  Typography } from '@mui/material'
import { map } from '@/utils/lodash'

const LotLoanForm = ({ lotLoanFields, renderInputFields  }) => (
  <>
    <Grid container>
      <Grid size={12}>
        <Typography variant="h6">Lot Loan</Typography>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={1}>
      {map(lotLoanFields, (field) => renderInputFields(false)(field))}
    </Grid>
  </>
)

export default LotLoanForm
